module.exports = " <div class=waterfall> <div class=show-photo> <div class=d-photo v-for=\"img in imgs\"> <img v-bind:src=img.webformatURL> <a v-link=\"{ name: 'PhotoDetail', params: {id: img.id }}\"> <span>提供者: {{img.user}}</span> <span>标签: {{img.tags}}</span> <span>喜欢人数: {{img.likes}}</span> <span>下载次数: {{img.downloads}}</span> </a> </div> </div> <div class=show-more> <a><i class=\"fa fa-spinner\" aria-hidden=true></i>加载中..</a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoList.vue
 ** module id = 71
 ** module chunks = 0
 **/